import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Button } from '@si-armes/dsfr-react';
import { useDispatch, useSelector } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from '../../../../../../store/usagerReducer';
import {
    API_RESTITUER_PRET,
    CONTEXT_RESTITUER_PRET,
} from '../../../../../../constants/apiUrls.constants';

const BoutonRestituerPret = ({ armesSelectionnees, rechargerTableau, fermerModale }) => {
    const dispatch = useDispatch();
    const { isLoading, erreur, data } = useSelector((state) => state.transferts.restituerPretStore);
    const [localLoading, setLocalLoading] = useState(false);

    const restituerPret = async () => {
        setLocalLoading(true);

        const uuidArme = armesSelectionnees[0].uniquid;

        await postAPI(
            usagerClientReducer,
            API_RESTITUER_PRET + uuidArme,
            {},
            CONTEXT_RESTITUER_PRET,
        )(dispatch);
    };

    useEffect(() => {
        if (localLoading && !isLoading) {
            setLocalLoading(false);

            fermerModale();

            if (data && !erreur) {
                rechargerTableau();
            }

            dispatch(reinitialiseAPI(CONTEXT_RESTITUER_PRET));
        }
    }, [localLoading, isLoading, erreur, data, fermerModale, rechargerTableau, dispatch]);

    return (
        <Button
            variant="primary"
            onClick={restituerPret}
            isLoading={localLoading}
            disabled={localLoading}
        >
            Restituer
        </Button>
    );
};

BoutonRestituerPret.propTypes = {
    armesSelectionnees: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string.isRequired,
        }).isRequired,
    ),
    rechargerTableau: PropTypes.func.isRequired,
    fermerModale: PropTypes.func.isRequired,
};

export default BoutonRestituerPret;
